import { Form, Input, message, Modal, Select } from "antd";
import React, { useEffect, useState } from "react";
import { RecoilState, useRecoilState } from "recoil";
import {
  apiCompaniesList,
  apiSaveLinkOrgService,
} from "../../../../../api/api";
import { CompanyServiceMatchType } from "../../../../../types";
import { companyList } from "../../state";

export const ModalNewLink = ({
  modalState,
  updateDataSource,
}: {
  modalState: RecoilState<boolean>;
  updateDataSource: React.Dispatch<
    React.SetStateAction<CompanyServiceMatchType[]>
  >;
}) => {
  const [form] = Form.useForm<any>();
  const [visible, setVisible] = useRecoilState(modalState);
  const [loading, setLoading] = useState<boolean>(false);
  const [companies, setCompanies] = useRecoilState(companyList);

  const createLinkOrgService = async (values: { [index: string]: string }) => {
    setLoading(true);
    const { serviceId, serviceName, companyId } = values;
    try {
      const resp = await apiSaveLinkOrgService(
        companyId,
        serviceId,
        serviceName
      );
      updateDataSource((oldArray) => [resp.result, ...oldArray]);
      message.success("Запись добавлена");
    } finally {
      setLoading(false);
    }
    setVisible(false);
  };

  const getCompanies = async () => {
    const resp = await apiCompaniesList();
    setCompanies(resp.result);
  };

  useEffect(() => {
    if (visible && !companies) {
      getCompanies();
    }
  }, [visible]);

  useEffect(
    () => () => {
      if (companies) setCompanies(undefined);
    },
    []
  );

  return (
    <Modal
      title="Добавить"
      visible={visible}
      onOk={() => form.submit()}
      onCancel={() => setVisible(false)}
      confirmLoading={loading}
      afterClose={() => {
        form.resetFields();
      }}
      maskClosable={false}
      width="500px"
      cancelText="Отменить"
      okText="Добавить"
      forceRender
    >
      <Form
        form={form}
        onFinish={createLinkOrgService}
        labelCol={{
          span: 7,
        }}
      >
        <Form.Item label="Организация" name="companyId">
          <Select loading={!companies}>
            {companies?.map((el) => (
              <Select.Option value={el.inn}>{el.companyName}</Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item label="Идентификатор услуги" name="serviceId">
          <Input />
        </Form.Item>
        <Form.Item label="Название услуги" name="serviceName">
          <Input.TextArea />
        </Form.Item>
      </Form>
    </Modal>
  );
};
